export default __webpack_public_path__ + "static/media/david.7adf1c87.jpg";